<template>
  <v-sheet class="d-flex flex-column align-center bg-transparent px-4" elevation="0">
    <v-icon icon="mdi-transfer-up" size="48" color="primary" :class="$device.isMobile?'align-self-end pr-6':''"/>
    <v-sheet style="position: relative; top: -30px;" rounded
             elevation=8>
      <v-sheet color="primary" class="d-flex justify-center align-center rounded-t px-4 py-2">
        <span class="text-subtitle-1 font-weight-bold justify-center text-uppercase font-italic">
          {{ t('select-store') }}
        </span>
      </v-sheet>
      <v-sheet class="d-flex flex-column ga-2 pa-2">
        <AtomsCountrySelector v-model="currentCountry"
                              :multiple="false" x
                              :with-chips="false"/>
        <AtomsStoreSelector v-model="currentStore"
                            :disabled="!currentCountry"
                            :selected-country="currentCountry"/>
      </v-sheet>
      <v-card-actions>
        <v-spacer/>
        <v-btn :text="t('cancel')" @click="close" class="text-none font-weight-bold text-subtitle-1"/>
        <v-btn :loading="loading" variant="flat" color="primary"
               :disabled="currentStore==undefined || currentStore==decathStore?.selectedStore"
               @click="updateStore" text="OK" class="text-subtitle-1 font-weight-bold"/>
      </v-card-actions>
    </v-sheet>

  </v-sheet>
</template>

<script setup lang="ts">

import type {Country} from "~/types/countries";
import type {DecathlonStore} from "~/types/decathlonStore";
import {useI18n} from "vue-i18n";

const {t} = useI18n()
const decathStore = useDecathlonStores()
const loading = ref(false)
const currentCountry = ref<Country | undefined>(decathStore?.selectedCountry)
const currentStore = ref<DecathlonStore | undefined>(decathStore?.selectedStore)

const {adminUi, close} = defineProps<{
  adminUi: boolean
  close: () => void
}>()

watch(currentCountry, (newValue: Country | undefined) => {
  currentStore.value = undefined
})

const updateStore = async () => {
  loading.value = true
  if (currentCountry.value && currentStore.value) {
    decathStore.setSelectedCountry(currentCountry.value)
    decathStore.setSelectedStore(currentStore.value)
    if (decathStore.selectedCrossDiagExist())
      await navigateTo(adminUi ? `/admin` : `/store`)
    else {
      // On ne vide pas selectedCrossDiag ici : tant qu'aucune valeur nouvelle n'est choisie,
      // l'ancienne référence reste affichée (elle ne matchera simplement aucun diagnostic du
      // nouveau magasin sur /choose-diag). La vraie sélection sera écrasée par une valeur valide
      // dès que l'utilisateur choisit un diagnostic (ChooseDiag.vue → selectItem). Cela évite de
      // faire transiter l'état global par "undefined" pendant que d'autres pages/watchers
      // restent montés le temps que la navigation asynchrone se termine.
      await navigateTo("/choose-diag")
    }
  }
  loading.value = false
  close()
}

</script>

